import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';
import { debounce, uniqBy } from 'lodash';
import SelectCustomSkills from '../../shared/SkillSelect/SkillSelect';

function SkillsSelector ({ allSkills, value, onChange, passed_skills, skills_inprogress, userAllSkills, selectSkillAsObject, autoTagText, ...props }) {
  const [skillIds, setSkillIds] = useState([]);
  const [skills, setSkills] = useState([]);
  const [listAllSkills, setAllSkills] = useState([]);
  const [key, setKey] = useState('key');

  const extractSkillsFromText = (text, defaultValue = []) => {
    if (typeof text !== 'string' || !Array.isArray(allSkills)) return;
    if (text === '<br>') text = '';
    const skillsSelectedByUser = (defaultValue || []).filter(item => !item.auto_tagging);
    const textSkillsSelectedByUser = skillsSelectedByUser.map(skill => skill.skill_name).join('  ');
    text = text.trim().toLowerCase();
    const selectedList = allSkills
      .map(item => ({ skill_id: item.id, skill_name: item.skill_name }))
      .filter(item => !skillsSelectedByUser.find(elm => elm.skill_id === item.skill_id))
      .map(item => {
        item.skills = item.skill_name
          .split(/[,]/) // split only on commas
          .map(name => name.toLowerCase().trim())
          .filter(name => name)
          // eslint-disable-next-line no-useless-escape
          .map(name => name.replace(/([^a-zA-Z0-9\.\s\-\/])/g, '\\$1'))
          // eslint-disable-next-line no-useless-escape
          .map(name => name.replace(/([\.\s\-])/g, '[\\.\\s\\-]*?'))
          .map(name => new RegExp('(?<=^|\\s)' + (name.length > 2 ? name.replace(/\b(js)\b/g, '($1)?') : name) + '(?=[\\.,]?\\s|$)', 'gim'));
        return item;
      })
      .filter(item => item.skills.every(name => {
        try {
          return text.match(name) || (textSkillsSelectedByUser.match(name) && item.skills.some(skill => !textSkillsSelectedByUser.match(skill)));
        } catch (e) {
          return false;
        }
      }))
      .map(item => {
        item.auto_tagging = true;
        return item;
      });
    const list = [...skillsSelectedByUser, ...selectedList];
    let newSkillsList = list.filter(item => !skills.find(elm => elm.skill_id === item.skill_id));
    newSkillsList = [...skills, ...newSkillsList];
    setSkills(newSkillsList);
    setKey('key' + (new Date()).getTime());
    if (onChange) onChange(newSkillsList);
  };

  const extractSkillsFromTextDebounce = useRef(debounce(extractSkillsFromText, 500));

  useEffect(() => {
    extractSkillsFromTextDebounce.current(autoTagText, value);
  }, [autoTagText]);

  useEffect(() => {
    setAllSkills((allSkills || []).map(skill => ({ ...skill, skill_id: skill.id })));
  }, [allSkills]);

  useEffect(() => {
    let listIds = [];
    if (selectSkillAsObject) {
      listIds = (Array.isArray(value) ? value : []).map(skill => skill.skill_id);
    } else {
      listIds = (Array.isArray(value) ? value : []).map(id => parseInt(id)).filter(id => id);
    }
    setSkillIds(listIds);
    let list = (allSkills || []).filter(skill => listIds.includes(skill.id)).map(skill => ({ ...skill, skill_id: skill.id }));
    list = uniqBy([...userAllSkills, ...list], skill => +skill.skill_id);
    setSkills(list);
    setKey('key' + (new Date()).getTime());
  }, [value, userAllSkills]);

  const onSkillsChange = (listIds) => {
    if (!onChange) return;
    if (selectSkillAsObject) {
      let list = (Array.isArray(value) ? value : []);
      list = list.filter(skill => listIds.includes(skill.skill_id));
      const ids = list.map(skill => skill.skill_id);
      const newIds = listIds.filter(id => !ids.includes(id));
      const newlist = allSkills
        .filter(skill => newIds.includes(skill.id))
        .map((skill) => ({
          skill_id: skill.id,
          skill_name: skill.skill_name
        }));
      list = [...list, ...newlist];
      onChange(list);
    } else {
      onChange(listIds);
    }
  };

  const getSkillNote = (skill) => {
    if (!autoTagText) return null;
    const n = skill.skill_name
      .split(/[,]/) // split only on commas
      .map(name => name.toLowerCase().trim())
      .filter(name => name)
      // eslint-disable-next-line no-useless-escape
      .map(name => name.replace(/([^a-zA-Z0-9\.\s\-\/])/g, '\\$1'))
      // eslint-disable-next-line no-useless-escape
      .map(name => name.replace(/([\.\s\-])/g, '[\\.\\s\\-]*?'))
      .map(name => new RegExp('(?<=^|\\s)' + (name.length > 2 ? name.replace(/\b(js)\b/g, '($1)?') : name) + '(?=[\\.,]?\\s|$)', 'gim'))
      .map(regex => autoTagText.match(regex))
      .reduce((acc, result) => {
        if (Array.isArray(result)) {
          return Math.min(result.length, acc);
        }
        return 0;
      }, Infinity);
    if (n === Infinity || n === 0) {
      return 'No mentions';
    }
    return `Mentioned ${n} time${n > 1 ? 's' : ''}`;
  };

  return (
    <Form.Item {...props} className={autoTagText ? 'SkillsSelector' : null} >
      <SelectCustomSkills
        key={key}
        activeProject={{ skills: listAllSkills }}
        skillIds={skillIds}
        onSkillsChange={onSkillsChange}
        skills={skills}
        // skillRender={skillRender}
        getSkillNote={getSkillNote}
        base_skills={listAllSkills}
        passed_skills={passed_skills}
        skills_inprogress={skills_inprogress}
      />
    </Form.Item>
  );
}

SkillsSelector.propTypes = {
  allSkills: PropTypes.array,
  value: PropTypes.any,
  passed_skills: PropTypes.any,
  skills_inprogress: PropTypes.any,
  userAllSkills: PropTypes.any,
  selectSkillAsObject: PropTypes.bool,
  autoTagText: PropTypes.string,
  onChange: PropTypes.func
};

export default SkillsSelector;
